<div class="business-content design-factory">
  <h3 class="h3" [class.mb-4]="!showTabs">{{ subtitle }}</h3>
  <ul ngbNav *ngIf="showTabs" #nav="ngbNav" class="nav-tabs">
    <li ngbNavItem *ngFor="let tab of tabs">
      <a ngbNavLink [routerLink]="tab.link" routerLinkActive="active">{{ tab.title }}</a>
    </li>
  </ul>
  <router-outlet></router-outlet>
</div>
